//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateChoferes } from "@/typings/store/plugins/easyFirestore/choferes";

const getters: GetterTree<StateChoferes, State> = {
  get(state) {
    return state.all;
  },
  getArray(state) {
    return Object.values(state.all);
  },
};

const choferes = {
  firestorePath: "{env}/v1/empresas/{idEmpresa}/choferes",
  firestoreRefType: "collection",
  moduleName: "choferes",
  statePropName: "all",
  namespaced: true,

  state: {},
  getters,
  mutations: {},
  actions: {},
};

export default choferes;
